<mat-card class="menu-single m-2">
    <div *ngIf="user" fxLayout="row wrap" class="flex-wrapper">
        <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
            <img *ngIf="user.user_image != null" src={{hostService.getHttpsImage()+user.user_image}} class="w-100">
            <img *ngIf="user.user_image == null" [src]="'assets/images/avatars/avatar-2.png'" class="w-100">
        </div>
        <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
            <h1 class="secondary-font">{{user.user_name}} {{user.user_surname}}</h1> 
            <div fxLayout="row" fxLayoutAlign="start center">
                <span class="mx-2 text-muted" *ngIf="user.user_profil == 'USER'">Utilisateur</span>
                <span class="mx-2 text-muted" *ngIf="user.user_profil == 'ADMIN'">Administrateur</span>
            </div> 
            <h2 class="primary-color py-3"> 
                {{user.email}} 
            </h2> 
            <!-- <div fxLayout="row" fxLayoutAlign="start center">
                <app-quantity-counter [value]="menuItem.cartCount" [step]="1" [min]="1" [max]="1000" (onCounterChange)="counterChange($event)"></app-quantity-counter>
                <button mat-raised-button color="primary" class="uppercase mx-3" (click)="addToCart()">Add To Cart</button> 
                <button mat-icon-button (click)="addToFavorites()" class="text-muted" matTooltip="Add To Favorite">
                    <mat-icon class="mat-icon-lg">favorite_border</mat-icon>
                </button>
            </div>  -->
            <div class="py-3"> 
                <p fxLayout="row" fxLayoutAlign="start center" class="mb-1">
                    <mat-icon color="primary" class="mat-icon-sm">call</mat-icon>
                    <span class="px-1">Phone :</span> 
                    <span class="fw-500">{{user.mobile}}</span>
                </p>
                <p fxLayout="row" fxLayoutAlign="start center" class="mb-1">
                    <mat-icon color="primary" class="mat-icon-sm">location_on</mat-icon>
                    <span class="px-1">Adresse :</span> 
                    <span class="fw-500">{{user.user_adress}}</span>
                </p>
                <p fxLayout="row" fxLayoutAlign="start center" class="mb-1">
                    <mat-icon color="primary" class="mat-icon-sm">local_offer</mat-icon>
                    <span class="px-1">Ville:</span> 
                    <span class="fw-500">{{user.user_city}}</span>
                </p>
                <!-- <p fxLayout="row" fxLayoutAlign="start center" class="mb-1">
                    <mat-icon color="primary" class="mat-icon-sm">check_circle</mat-icon>
                    <span class="px-1">Code Postal :</span> 
                    <span class="fw-500">{{user.user_code_postal}}</span>
                </p> -->
                <p fxLayout="row" fxLayoutAlign="start center" class="mb-1">
                    <mat-icon color="primary" class="mat-icon-sm">date_range</mat-icon>
                    <span class="px-1">Inscrit depuis le :</span> 
                    <span class="fw-500">{{user.created_at | date:"dd MMMM, yyyy 'at' HH:mm"}}</span>
                </p>    
            </div>   
            <h3>Description</h3>
            <p>{{user.user_description}}</p> 
            <div fxLayout="row" fxLayoutAlign="start center" class="text-muted divider pt-3">
                <span class="fw-500">Permis: </span>
            </div>  
            <ul class="p-3">
                <li>N° : {{user.driver_licenses_number}}</li>
                <li>Pays : {{ user.driver_licenses_country == null ?'':country.name}}</li>
                <li> Date : {{user.driver_licenses_date | date:"dd MMMM, yyyy"}}</li>
            </ul>
            <div fxLayout="row" fxLayoutAlign="start center" class="text-muted divider pt-3">
                <span class="fw-500">CNI: </span>
            </div>  
            <ul class="p-3">
                <li>N° : {{user.cni_number}}</li>
                <li>Pays : {{ user.cni_country == null ?'':countryCNI.name}}</li>
                <li> Date : {{user.cni_date | date:"dd MMMM, yyyy"}}</li>
            </ul>   
            <div fxLayout="row" fxLayoutAlign="start center" class="text-muted divider pt-3">
                <span class="fw-500">CHIFFRE D'AFFAIRE: </span>
            </div>  
            <ul class="p-3">
                <li> Somme générer : {{revenuetotal}} {{currency}} depuis {{ this.user?.created_at | date:"dd MMMM, yyyy 'à' HH:mm" }}</li>
                <li>Somme reçu :  {{transferTotal}} {{currency}}</li>
                <li>Somme restante : {{currentAmount}} {{currency}}</li>
            </ul>
            <div fxLayout="row" fxLayoutAlign="start center" class="divider pt-3">
                <span class="fw-500">Actions</span>
                <button mat-icon-button color="primary" [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger" matTooltip="Modifier le profil de l'utilisateur">
                    <mat-icon> border_color</mat-icon>
                </button>
                <mat-menu #menu="matMenu" xPosition="before">
                    <span mat-menu-item (click)="changeProfil('USER', user.id, 'Utilisateur')">Utilisateur</span>
                    <span mat-menu-item (click)="changeProfil('ADMIN', user.id, 'Administrateur')">Administrateur</span>
                </mat-menu>
                <button mat-icon-button color="warn" (click)="deleteUser(user.id)" matTooltip="Supprimer">
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
        </div>  
        
        <div fxFlex="100" class="px-3 mt-5">

            <app-permission-user [idUser]="idUser"></app-permission-user>
            
            
        </div> 

    </div>
</mat-card>
 

 
 
 